enum JobAssignmentStatus {
  Assigned = 'Assigned',
  Unassigned = 'Unassigned',
  Accepted = 'Accepted',
}

export default JobAssignmentStatus;
